import styled from 'styled-components';
import { Text, Pill, Link } from '@sketch/components';

const Title = styled.h1 `
  margin: 0 12px 12px 0;
  font-size: ${({ theme }) => theme.fontSizes.F};
  white-space: pre-line;
  transition: color ${({ theme }) => theme.transitions.duration[1]};
`;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background.tertiary.D};
  border-radius: ${({ theme }) => theme.radii.xlarge};

  transition: ${({ theme }) => `background  ${theme.transitions.duration[1]} ${theme.transitions.timing.easeInOut}`};

  :hover {
    background: ${({ theme }) => theme.colors.background.tertiary.C};

    ${Title} {
      color: ${({ theme }) => theme.colors.foreground.secondary.C};
    }
  }
`;
const TitleContainer = styled.div `
  margin: 20px 0 8px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const Content = styled(Text).attrs({
    textStyle: 'copy.quaternary.standard.E',
}) `
  margin: 0;
  white-space: pre-line;
  font-weight: initial;
`;
const Badges = styled.div `
  display: flex;
  margin-bottom: 12px;
`;
const StyledPill = styled(Pill) `
  :not(:first-child) {
    margin-left: 12px;
  }
`;
const StyledLink = styled(Link) `
  /* Reset all link styles */
  text-decoration: none;
  transition: none;
  white-space: nowrap;
  color: currentColor;

  &:hover {
    color: currentColor;

    ${Title} {
      /* underline Title on card hover */
      text-decoration: underline;
    }
  }

  &:active {
    color: currentColor;
  }
`;

export { Badges, Container, Content, StyledLink, StyledPill, Title, TitleContainer };
